if (typeof ModalDialog !== 'undefined' && !customElements.get('avalon-video-modal')) {
  class AvalonVideoModal extends ModalDialog {
    show(opener) {
      super.show(opener);

      // Shopify-hosted video: native player, play with sound on open.
      const video = this.querySelector('video');
      if (video) {
        video.muted = false;
        video.volume = 1;
        const played = video.play();
        if (played && played.catch) played.catch(() => {});
        return;
      }

      // External (YouTube/Vimeo): inject the iframe on open so it doesn't run in the background.
      const template = this.querySelector('[data-video-template]');
      const holder = this.querySelector('.avalon-video-modal__media');
      if (template && holder && !holder.querySelector('iframe')) {
        holder.appendChild(template.content.cloneNode(true));
      }
    }

    hide() {
      const video = this.querySelector('video');
      if (video) video.pause();

      // Stop external video by removing its iframe.
      const iframe = this.querySelector('iframe');
      if (iframe) iframe.remove();

      super.hide();
    }
  }

  customElements.define('avalon-video-modal', AvalonVideoModal);
}
